// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { SoftwareTypeSchema } from '../inputTypeSchemas/SoftwareTypeSchema'
import { SoftwareOwnershipSchema } from '../inputTypeSchemas/SoftwareOwnershipSchema'

/////////////////////////////////////////
// SOFTWARE SCHEMA
/////////////////////////////////////////

/**
 * Identified software/product/version observed on a Host XOR a NetworkService.
 * XOR enforced in the service layer (`exactly one of hostId / networkServiceId is set`).
 * unique criteria: surfaceId, serviceId, domainName - todo
 */
export const SoftwareSchema = z.object({
  softwareType: SoftwareTypeSchema,
  ownership: SoftwareOwnershipSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  networkServiceId: z.string().nullable(),
  vendor: z.string().nullable(),
  product: z.string(),
  version: z.string().nullable(),
  domainName: z.string().nullable(),
  domainId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  hostId: z.string().nullable(),
})

export type Software = z.infer<typeof SoftwareSchema>

export default SoftwareSchema;
